export default class DrupalAccessTokenApi {

  constructor() {
    this.baseUrl = '/csf-api-pivotal/get-access-token-from-session';
    this.baseUrlFournisseur = '/csf-api-fournisseur/get-access-token-from-session';
  }

  /*
  * Generic method to call drupal api to get the session access token
  * */
  async fetchPostRequest($type = 'broker') {
    const requestMetadata = {
      method: 'POST',
    };
    const url = $type === 'broker' ? this.baseUrl : this.baseUrlFournisseur;
    const response = await fetch(`${url}`, requestMetadata);
    return response.json();
  }

}
